// function languageNames(){
    let languages = process.env.REACT_APP_AVAILABLE_LANGUAGES;
    let names = process.env.REACT_APP_AVAILABLE_LANGUAGES_NAMES;

    languages = languages.split(" ");
    names = names.split(" ");

    let langsObj = {};

    languages.forEach((lang, index) => {
        langsObj[lang] = names[index];
    });

    // return langsObj;
// }

export default langsObj;